import { mapState } from 'vuex'

export default {

  computed: {
    ...mapState(['profileColorStyles']),
    userColorStyles() {
      const { primary, secondary, tertiary, bodyBackground, productBackground, tilesBackground, postsBackground, stickyPostsBackground, commentsBackground } = this.profileColorStyles
      return {
        '--primary-color': primary,
        '--secondary-color': secondary,
        '--tertiary-color': tertiary,
        '--primary-text-color': this.yiq(primary),
        '--secondary-text-color': this.yiq(secondary),
        '--tertiary-text-color': this.yiq(tertiary),
        '--body-background-color': bodyBackground,
        '--body-background-text-color': this.yiq(bodyBackground),
        '--tiles-background-color': tilesBackground,
        '--tiles-background-text-color': this.yiq(tilesBackground),
        '--posts-background-color': postsBackground,
        '--posts-background-text-color': this.yiq(postsBackground),
        '--sticky-posts-background-color': stickyPostsBackground,
        '--sticky-posts-background-text-color': this.yiq(stickyPostsBackground),
        '--product-background-color': productBackground,
        '--product-background-text-color': this.yiq(productBackground),
        '--comments-background-color': commentsBackground,
        '--comments-background-text-color': this.yiq(commentsBackground),
        '--primary-on-comments-background': this.isReadable(primary, commentsBackground) ? primary : this.yiq(commentsBackground)
      }
    }
  },
  methods: {
    yiq(color) {
      color = color.replace('#', '')
      const r = parseInt(color.substr(0, 2), 16)
      const g = parseInt(color.substr(2, 2), 16)
      const b = parseInt(color.substr(4, 2), 16)
      const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000
      return (yiq >= 128) ? '#000' : '#fff'
    },
    isReadable(textColor, bgColor, threshold = 3.5) {
      textColor = textColor.replace('#', '')
      bgColor = bgColor.replace('#', '')

      const text = {
        r: parseInt(textColor.substr(0, 2), 16),
        g: parseInt(textColor.substr(2, 2), 16),
        b: parseInt(textColor.substr(4, 2), 16)
      }
      const bg = {
        r: parseInt(bgColor.substr(0, 2), 16),
        g: parseInt(bgColor.substr(2, 2), 16),
        b: parseInt(bgColor.substr(4, 2), 16)
      }

      // luminance (simplified)
      const textLum = (0.2126 * text.r + 0.7152 * text.g + 0.0722 * text.b) / 255
      const bgLum = (0.2126 * bg.r + 0.7152 * bg.g + 0.0722 * bg.b) / 255

      // contrast ratio
      const contrast = (Math.max(textLum, bgLum) + 0.05) / (Math.min(textLum, bgLum) + 0.05)

      // Return true if contrast meets threshold
      return contrast >= threshold
    }
  }
}
